import { Action } from 'redux';

import { IDataSourceInfo } from '../../../ts/models/IDataSourceInfo';
import { ChangeExtractDsToLive } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface ChangeExtractDsToLiveAction extends Action {
  datasources: IDataSourceInfo[];
}

export function changeExtractDsToLive(datasources: IDataSourceInfo[]): ChangeExtractDsToLiveAction {
  return {
    type: ChangeExtractDsToLive,
    datasources: datasources
  };
}

export const isChangeExtractDsToLiveAction = isActionFactory<ChangeExtractDsToLiveAction>(ChangeExtractDsToLive);
